import { render, staticRenderFns } from "./blood-oxygen-title-bar.vue?vue&type=template&id=604647aa"
import script from "./blood-oxygen-title-bar.vue?vue&type=script&lang=js"
export * from "./blood-oxygen-title-bar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports